import ScrollMagic from 'scrollmagic';

//スクロールアニメーション
class ScrollFade {
  constructor() {
      this.ANIMATION_CLASS = 'is-fire';

      let $section = document.querySelectorAll('.js-scroll:not(.is-fire)');
      if($section.length === null) {
          return;
      }
      let controller = new ScrollMagic.Controller();
      for(let i = 0; i < $section.length; i++) {
          let scene = new ScrollMagic.Scene({
              triggerElement: $section[i],
              triggerHook: 'onEnter',
              reverse: false,
              offset: 100
          })
              .addTo(controller);
          scene.on('enter', ()=>{
              $section[i].classList.add(this.ANIMATION_CLASS);
          });
          scene.on('end', ()=>{
              scene.destroy(true);
          });
      }
  }
}

new ScrollFade();

var $ = require('jquery');
$("body").append('<script src="https://www.youtube.com/iframe_api">');
let ytPlayer;
  setTimeout(function onYouTubeIframeAPIReady() {　// setTimeoutで0.5秒後に実行
    ytPlayer = new YT.Player(
      "js-player", // 埋め込む場所の指定
      {
        videoId: "O1cD_f3IE9I", // YouTubeのID,
        playerVars: {
          loop: 1,
          autoplay: 1,
          rel: 0,
          controls: 0,
          modestbranding: 1,
          widgetid: 1,
          playlist: "O1cD_f3IE9I",
          playsinline: 1, // スマホでも自動再生
          showinfo: 0,
          fs: 0,
        },
        events: {
          onReady: onPlayerReady,　// プレーヤーの準備ができたとき
          onStateChange: onPlayerStateChange,　// プレーヤーの再生、一時停止、終了したとき
        },
      }
    );

    function onPlayerReady(event) {
        event.target.mute();　// 音声を消す
        event.target.playVideo();　// 動画再生
    }

    function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.ENDED) {
          event.target.playVideo();
        }
    }
}, 500);


var $moviestart = $('#movie-start');

/*$("#movie-btn").on("click", function() {
    $moviestart.addClass('is-skip');

    $moviestart.find('.moviestart__inner').on('transitionend', function( e ){ 
        $(this).parent().remove();
    });
});*/

import "./module/jquery.cookie.js";

var cookie = $.cookie('moviestart');
if(cookie){
  $moviestart.addClass('is-skip');

  $moviestart.find('.moviestart__inner').on('transitionend', function( e ){ 
      $(this).parent().remove();
  });
}
$('#movie-btn').on('click',function(){
  $moviestart.addClass('is-skip');

  $moviestart.find('.moviestart__inner').on('transitionend', function( e ){ 
      $(this).parent().remove();
  });
  $.cookie('moviestart','is-skip', { //cookieにbnrReadという名前でonという値をセット
      expires: 1, //cookieの有効日数
      path:'/' //有効にするパス
  });
});